module.exports = __webpack_public_path__ + "static/media/visa.8af683e3.png";